// This component should support image size styles so possibly some of the styles will not be used.

import first from "lodash/first";
import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import type { Props as BaseImageProps } from "scmp-app/components/common/base-image";
import type { mainImagePrintArticleArticle$key } from "scmp-app/queries/__generated__/mainImagePrintArticleArticle.graphql";

import { Caption, Container, StyledBaseImage } from "./styles";

export type Props = {
  className?: string;
  imageProps: BaseImageProps;
  reference: mainImagePrintArticleArticle$key;
};

export const PrintArticleMainImage: FunctionComponent<Props> = ({
  className,
  imageProps,
  reference: reference_,
}) => {
  const article = useFragment(
    graphql`
      fragment mainImagePrintArticleArticle on Article {
        images {
          title
          url
          isSlideshow
          size_652x446: style(filter: { style: "652x446" }) {
            url
          }
        }
      }
    `,
    reference_,
  );

  const mainImage = article.images?.find(image => image?.isSlideshow) ?? first(article.images);

  const imageUrl = mainImage?.size_652x446?.url ?? "";

  return (
    <Container className={className}>
      <StyledBaseImage
        $objectFit="cover"
        src={imageUrl}
        title={mainImage?.title ?? ""}
        {...imageProps}
      />
      <Caption>{mainImage?.title}</Caption>
    </Container>
  );
};

PrintArticleMainImage.displayName = "PrintArticleMainImage";
